import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import AllStats from 'profile/components/all_stats';

export default connect(mapProfileToProps)(AllStats);



// WEBPACK FOOTER //
// ./profile/containers/all_stats.js